import React, {useState, useRef, useEffect} from 'react';
import {TextareaAutosize} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

const BlurChangeTextArea = ({ onChange, Icon, maxLength, label, disabled = false, ...props }: {
    onChange: (value: string) => void;
    maxLength?: number;
    label?: string;
    disabled?: boolean;
    Icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
    [key: string]: any
}) => {
    const [value, setValue] = useState(props.value || '');
    const prevValue = useRef(value);

    useEffect(() => {
        setValue(props.value)
    }, [props.value])

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (maxLength && value.length > maxLength) {
            return;
        }
        setValue(e.target.value);
    };

    const handleBlur = () => {
        if (value !== prevValue.current) {
            onChange(value);
            prevValue.current = value;
        }
    };

    const handleFocus = () => {
        prevValue.current = value;
    };

    const labelStyle = {
        color: 'rgba(10, 25, 35, 0.9)',
        fontSize: '13px',
        lineHeight: '15px'
    }

    return (
        <div style={{position: 'relative'}}>
            <span style={{ ...labelStyle, ...(disabled && { color: 'rgba(10, 25, 35, 0.4)' }) }}>{label}</span>
            <TextareaAutosize
                {...props}
                disabled={disabled}
                maxLength={maxLength}
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                onFocus={handleFocus}
            />
            {Icon && <Icon style={{
                position: 'absolute',
                top: '32px',
                right: '16px'
            }}/>}
            {maxLength && (<Typography
                variant="caption"
                color={value.length === maxLength ? 'error' : 'textSecondary'}
                display="block"
                align="left"
            >
                {value.length}/{maxLength}
            </Typography>)}
        </div>
    );
};

export default BlurChangeTextArea
